export default __webpack_public_path__ + "static/media/About_Landing-11.64922b7c.png";